const PHONE_SPLIT_RE = /(\+\d{1,3}(?:[ .-]?\d{2,4}){2,4})/g;
const PHONE_TEST_RE = /^\+\d{1,3}(?:[ .-]?\d{2,4}){2,4}$/;

/** Converts phone numbers like "+34 671 424 214" inside plain text into clickable tel: links. */
export function linkifyPhones(text = "") {
  return text.split(PHONE_SPLIT_RE).map((part, i) => {
    if (!PHONE_TEST_RE.test(part)) return part;
    const tel = part.replace(/[^\d+]/g, "");
    return (
      <a
        key={i}
        href={`tel:${tel}`}
        data-testid={`phone-link-${tel}`}
        className="text-terra underline decoration-terra/40 underline-offset-4 hover:decoration-terra transition-colors whitespace-nowrap"
      >
        {part}
      </a>
    );
  });
}
